export function contains<Value>(values: ReadonlyArray<Value>, value: Value): boolean {
	return values.indexOf(value) >= 0;
}

export function isEnumValue<EnumType extends { [_ in keyof EnumType]: string }>(enumType: EnumType, value: string): boolean {
	return Object.values(enumType).includes(value);
}
